export default __webpack_public_path__ + "static/media/perfil-icon.4b2e927e.svg";